export enum EventTabsEnum {
  Registrations = 'registrations',
}
